import { render } from "./ImageUploader.vue?vue&type=template&id=1c6142c1"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"

import "./ImageUploader.vue?vue&type=style&index=0&id=1c6142c1&lang=scss"
script.render = render

export default script